export default "__VITE_ASSET__Csu$7OGF__"